import React from 'react';
import styled from 'styled-components';

interface ScrollableProps {
  children: any;
}

const Scrollable = ({ children }: ScrollableProps) => (
  <ScrollableContainer>{children}</ScrollableContainer>
);

export default Scrollable;

export const ScrollableContainer = styled.div`
  position: relative;
  overflow: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;

  &::-webkit-scrollbar {
    display: none;
  }
`;
